import {Stack, type StackProps, Tooltip, Typography} from '@mui/material';

const Title = ({
  title,
  tooltip,
  ...rest
}: {
  title: string;
  tooltip?: string;
} & StackProps) => {
  return (
    <Stack {...rest}>
      <Tooltip title={tooltip ?? ''} placement="right">
        <Typography variant="paperTitle" color="textSecondary">
          {title}
        </Typography>
      </Tooltip>
    </Stack>
  );
};

export default Title;
